/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type VisibilityBoardAddressRow_rowData$ref: FragmentReference;
declare export opaque type VisibilityBoardAddressRow_rowData$fragmentType: VisibilityBoardAddressRow_rowData$ref;
export type VisibilityBoardAddressRow_rowData = {|
  +id: string,
  +address: string,
  +description: string,
  +visibilityBoard: {|
    +id: string,
    +name: string,
  |},
  +$refType: VisibilityBoardAddressRow_rowData$ref,
|};
export type VisibilityBoardAddressRow_rowData$data = VisibilityBoardAddressRow_rowData;
export type VisibilityBoardAddressRow_rowData$key = {
  +$data?: VisibilityBoardAddressRow_rowData$data,
  +$fragmentRefs: VisibilityBoardAddressRow_rowData$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VisibilityBoardAddressRow_rowData",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VisibilityBoard",
      "kind": "LinkedField",
      "name": "visibilityBoard",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VisibilityBoardAddress",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'aa7a3589f44dfe9423daa01bb76d21dd';

module.exports = node;
